// src/pages/LegalNotice.js
// Legal notice page — company registration details and legal disclaimers.

import React from 'react';
import usePageTitle from '../hooks/usePageTitle';

const LegalNotice = () => {
    usePageTitle('Legal Notice', 'Legal notice and company information for MAISON D\'OUD Limited.');

    return (
        <div className="bg-background min-h-screen pt-32 pb-24 px-6 transition-colors duration-300">
            <div className="max-w-4xl mx-auto">
                <h1 className="text-4xl font-light text-foreground mb-2 tracking-wide">Legal Notice</h1>
                <p className="text-muted-foreground text-sm mb-12">Last updated: April 23, 2026</p>

                <div className="space-y-10 text-muted-foreground leading-relaxed">

                    <section>
                        <h2 className="text-xl font-medium text-foreground mb-4">Company Information</h2>
                        <div className="space-y-3">
                            <div>
                                <p className="text-foreground font-medium">Trade Name</p>
                                <p>MAISON D'OUD LIMITED</p>
                            </div>
                            <div>
                                <p className="text-foreground font-medium">Registered Address</p>
                                <p>Munster, Ireland</p>
                            </div>
                            <div>
                                <p className="text-foreground font-medium">Company Registration Number</p>
                                <p>799450</p>
                            </div>
                            <div>
                                <p className="text-foreground font-medium">Email</p>
                                <p><a href="mailto:support@maisondoud.com" className="text-[#CEAC8F] hover:underline">support@maisondoud.com</a></p>
                            </div>
                        </div>
                    </section>

                    <section>
                        <h2 className="text-xl font-medium text-foreground mb-4">Website</h2>
                        <p>This website is operated by MAISON D'OUD and is hosted on Netlify. The e-commerce functionality is powered by Shopify.</p>
                    </section>

                    <section>
                        <h2 className="text-xl font-medium text-foreground mb-4">Intellectual Property</h2>
                        <p>All content on this website including text, images, logos and design is the property of MAISON D'OUD and is protected under applicable intellectual property laws. Any reproduction, distribution or use of our content without prior written permission is strictly prohibited.</p>
                    </section>

                    <section>
                        <h2 className="text-xl font-medium text-foreground mb-4">Liability</h2>
                        <p>While we take care to ensure the accuracy of the information on this website, we cannot guarantee that it is always complete or up to date. MAISON D'OUD accepts no liability for any errors or omissions, or for any loss or damage arising from reliance on the information provided.</p>
                    </section>

                    <section>
                        <h2 className="text-xl font-medium text-foreground mb-4">Governing Law</h2>
                        <p>This legal notice is governed by the laws of Ireland. Any disputes arising from the use of this website are subject to the exclusive jurisdiction of the Irish courts.</p>
                    </section>

                    <section>
                        <h2 className="text-xl font-medium text-foreground mb-4">Contact</h2>
                        <p>For any legal enquiries, please contact us at <a href="mailto:support@maisondoud.com" className="text-[#CEAC8F] hover:underline">support@maisondoud.com</a>.</p>
                    </section>

                </div>
            </div>
        </div>
    );
};

export default LegalNotice;